import { createReducer, on } from '@ngrx/store'
import { AccountStatus } from '../../account-status.enum'
import * as fromActions from '../actions'

export const accountFeatureKey = 'account'

export interface AccountState {
  status: AccountStatus
  temporaryBlockExpiration: Date | null
}

export const initialState: AccountState = {
  status: AccountStatus.unknown,
  temporaryBlockExpiration: null,
}

export const reducer = createReducer(
  initialState,
  on(fromActions.accountStatusReceived, (state, { accountStatus }) => ({ ...state, status: accountStatus })),
  on(fromActions.setTemporaryBlockExpiration, (state, { date }) => ({ ...state, temporaryBlockExpiration: date })),
)
